<template>
	<div style="width: 100%">
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="商品信息：">
				<el-cascader v-model="typeKeyId" size="small" :options="goodsTypeList" :props="cascaderProps" placeholder="请选择商品信息" clearable filterable @change="changeType"></el-cascader>
			</el-form-item>
			<el-form-item label="球镜：">
				<el-select v-model="formInline.qiuJing" size="small" style="width: 120px" placeholder="请选择球镜" clearable filterable>
					<el-option v-for="item in qiuJingList" :key="item" :label="item" :value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="柱镜：">
				<el-select v-model="formInline.zhuJing" size="small" style="width: 120px" placeholder="请选择柱镜" clearable filterable>
					<el-option v-for="item in zhuJingList" :key="item" :label="item" :value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="操作时间：">
				<el-date-picker
					v-model="dateRange"
					size="small"
					type="daterange"
					value-format="yyyy-MM-dd"
					format="yyyy-MM-dd"
					range-separator="~"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					clearable
					@change="handleDateChange"
				></el-date-picker>
			</el-form-item>
			</lcsj-filter>
		<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData"></STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import { GetAllGoodsTypeTreePageList } from "@/api/baseDataApi.js";
import { GetWareHouseHistoryList, GetWareHouseJingOptions } from "@/api/storeOrderApi.js";
export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				goodsTypeKeyId: "",
				qiuJing: "",
				zhuJing: "",
				createTimeStart: null,
				createTimeEnd: null
			},
			typeKeyId: "",
			goodsTypeList: [],
			cascaderProps: {
				value: "keyId",
				label: "name",
				children: "subList",
				checkStrictly: false,
				expandTrigger: "hover"
			},
			qiuJingList: [],
			zhuJingList: [],
			dateRange: null,
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "goodsTypeName",
					label: "商品类型",
					align: "center"
				},
				{
					prop: "qiuJing",
					label: "球镜",
					align: "center"
				},
				{
					prop: "zhuJing",
					label: "柱镜",
					align: "center"
				},
				{
					prop: "yuanQuantity",
					label: "原数量",
					align: "center"
				},
				{
					prop: "xianQuantity",
					label: "修改后数量",
					align: "center"
				},
				{
					prop: "creator",
					label: "操作人",
					align: "center"
				},
				{
					prop: "createTime",
					label: "操作时间",
					align: "center"
				}
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetAllGoodsTypeTreePageList();
		this.getJingOptions();
		this.getListData();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取商品类型数据
		GetAllGoodsTypeTreePageList() {
			GetAllGoodsTypeTreePageList({})
				.then((res) => {
					if (res.code == 1) {
						this.goodsTypeList = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 获取球镜/柱镜下拉选项（跟随商品类型）
		getJingOptions() {
			GetWareHouseJingOptions({ goodsTypeKeyId: this.formInline.goodsTypeKeyId || "" })
				.then((res) => {
					if (res.code == 1) {
						this.qiuJingList = res.data.qiuJingList || [];
						this.zhuJingList = res.data.zhuJingList || [];
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("球镜/柱镜选项加载失败，请稍后再试！");
				});
		},
		changeType(value) {
			if (value && value.length > 0) {
				this.formInline.goodsTypeKeyId = value[value.length - 1];
			} else {
				this.formInline.goodsTypeKeyId = "";
			}
			// 商品类型变化后球镜/柱镜的可选范围随之变化，清掉已选避免查不到数据
			this.formInline.qiuJing = "";
			this.formInline.zhuJing = "";
			this.getJingOptions();
			this.search();
		},
		// 操作时间范围（清空时归一化为 null，避免后端非可空类型反序列化失败）
		handleDateChange(value) {
			if (value && value.length === 2) {
				this.formInline.createTimeStart = value[0];
				this.formInline.createTimeEnd = value[1];
			} else {
				this.formInline.createTimeStart = null;
				this.formInline.createTimeEnd = null;
			}
			this.search();
		},
		changePages() {},
		// 获取列表（不传 searchKey，即查询全部商品的库存手动变更记录）
		getListData() {
			this.loading = true;
			GetWareHouseHistoryList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.typeKeyId = "";
			this.dateRange = null;
			this.getJingOptions();
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped></style>
